import React, { useState } from 'react';
import { AddressSearch, ListingSearchProps, Popconfirm } from 'components';
import { IContactListing } from '@bb/contacts';
import AddElement from './AddElement';
import Label from './Label';
import ListingResult from '../../../../../components/AddressSearch/ListingResult';
import { DRAWER_WIDTH } from '../../../constants';

interface AddListingProps {
  onSelectOption: ListingSearchProps['onSelect'];
  isBuyer: boolean;
  listings: IContactListing[];
}

const AddListing: React.FC<AddListingProps> = ({
  onSelectOption,
  isBuyer,
  listings,
}) => {
  const [active, setActive] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);

  const onSelect = (isContact: boolean, item?: any) => {
    setActive(false);
    onSelectOption({ ...(item || currentItem), isContact });
  };

  return active ? (
    <>
      <Label label="Listing" />
      <AddressSearch
        autoFocus
        type="listing"
        customRenderer={(item: any) => {
          if (listings?.some(listing => listing.id === item.id)) return null;
          return (
            <div onMouseDown={ev => ev.preventDefault()}>
              <Popconfirm
                width={DRAWER_WIDTH}
                title="Would you like to add this contact to the showing configuration of this listing?"
                okText="Yes"
                cancelText="Do not add"
                onConfirm={() => onSelect(true)}
                onCancel={() => onSelect(false)}
                disabled={isBuyer}
                overlayStyle={{ zIndex: 2001 }}
              >
                <ListingResult
                  item={item}
                  onClick={() => {
                    setCurrentItem(item);
                    if (isBuyer) {
                      onSelect(false, item);
                    }
                  }}
                />
              </Popconfirm>
            </div>
          );
        }}
      />
    </>
  ) : (
    <AddElement label="Listing" onClick={() => setActive(true)} />
  );
};

export default AddListing;
